import { createFeatureSelector } from 'features/create-feature-selector';
import { createSelector } from 'reselect';

const featureRootSelector = createFeatureSelector('yandexSplit');

export const getYandexSplitSession = createSelector(featureRootSelector, (f) => f?.session);
